"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const geniusTable_1 = __importDefault(require("../records/geniusTable"));
const getMonthlyCoefficients_1 = __importDefault(require("../records/getMonthlyCoefficients"));
const lifeBaseCoefficients_1 = __importDefault(require("../records/lifeBaseCoefficients"));
const lifeBaseTable_1 = __importDefault(require("../records/lifeBaseTable"));
const potentialTable_1 = __importDefault(require("../records/potentialTable"));
const getBirthdayDetails_1 = __importDefault(require("./getBirthdayDetails"));
const getFactors_1 = __importDefault(require("./getFactors"));
/**
 * Get the personality information corresponding to the specified birthday.
 * @param birth Specify a birthday within the range from February 1, 1873,
 * to December 31, 2050.
 *
 * Ignore the time information.
 * @returns The object that the personality information.
 *
 * If the date is over the range, it will be `undefined`.
 */
exports.default = (birth) => {
    const birthObj = new Date(birth);
    const monthlyCoefficients = getMonthlyCoefficients_1.default(birthObj);
    if (Number.isNaN(monthlyCoefficients)) {
        return undefined;
    }
    const { month, ...details } = getBirthdayDetails_1.default(new Date(birthObj));
    const { cycle, getXY, inner, lifeBase, outer, potentials, workStyle } = getFactors_1.default({
        ...details,
        month,
        monthlyCoefficient: monthlyCoefficients,
    });
    const lifeBaseCoef = lifeBaseCoefficients_1.default(month.month, lifeBase);
    const p = potentials.map((v) => potentialTable_1.default(getXY(v)));
    return {
        cycle,
        inner: geniusTable_1.default(getXY(inner)),
        lifeBase: lifeBaseTable_1.default(getXY(lifeBaseCoef)),
        outer: geniusTable_1.default(getXY(outer)),
        potentials: [p[0], p[1]],
        workStyle: geniusTable_1.default(getXY(workStyle)),
    };
};
//# sourceMappingURL=getPersonality.js.map